import { Fragment } from 'react'
import ImageBlock from '../ImageBlock/ImageBlock'
import VideoBlock from '../VideoBlock/VideoBlock'
import Link from "next/link"

const ProjectHeader = (props) => {

  const { title, dates, description, image, video } = props

  const contentHTML = () => {
    return { __html: description }
  }

  const videoContent = (videoUrl) => {
    const match = videoUrl.match(/vimeo\.com\/(\d+)/);
    const vimeoCode = match ? match[1] : ''; // Extracted Vimeo code or empty string if no match
    return {
      __html: `<div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/${vimeoCode}?h=000000&autoplay=1&loop=1&muted=1&controls=0&title=0&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe></div>`
    };
  }

  return (
    <Fragment>
      <div className="ProjectHeader">
        <div className="ProjectHeader-inner">
          <div className="ProjectHeader-intro">
            <div className="ProjectHeader-backButtonWrapper">
              <Link href={'/projects'}>
                <a className="ProjectHeader-backButton">
                  <svg>
                    <use xlinkHref="#icon-chevron-right"/>
                  </svg>
                  <span>Projects</span>
                </a>
              </Link>
            </div>
            {dates.length &&
            <div className="ProjectHeader-duration">
              <span>{dates[0].started} — {dates[0].ended}</span>
            </div>
            }
            <div className="ProjectHeader-content">
              {title &&
              <div className="ProjectHeader-title">
                <h1>{title}</h1>
              </div>
              }
              {description &&
              <div className="ProjectHeader-text" dangerouslySetInnerHTML={contentHTML()}/>
              }
            </div>
          </div>
        </div>
      </div>
      {video && video.length &&
        <div className='ImageBlock' dangerouslySetInnerHTML={videoContent(video)} />
      }
      {(!video) && image.length &&
      <ImageBlock alignment={`center`} image={image} caption={image[0].caption}/>
      }
    </Fragment>
  )
}

export default ProjectHeader
